module.exports = __webpack_public_path__ + "static/media/spinner.078aa3f0.gif";